export default __webpack_public_path__ + "static/media/memoryRecall.7842d05c.svg";